<h3>{{ field.key | translate }}</h3>
<div id="container">
  <div id="rowsContainer" cdkDropList *ngIf="field.dynamicListRowConstrainedFields.length != 0" (cdkDropListDropped)="drop($event)">
    <ng-container *ngFor="let rowField of field.dynamicListRowConstrainedFields; index as idx">
      <div class="row" cdkDrag [cdkDragDisabled]="!field.editable">

        <span *ngIf="field.editable" class="drag-icon">
          <mat-icon>drag_indicator</mat-icon>
        </span>

        <dynamic-cell-form [fields]="rowField" />

        <div *ngIf="field.editable"
             matTooltip="{{ 'deleteRow' | translate }}"
             matTooltipClass="big-tooltip">
          <button mat-mini-fab
                  color="primary"
                  class="deleteButton"
                  type="button"
                  (click)="deleteRow(idx)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
    </ng-container>
  </div>
  <div *ngIf="field.editable" id="addButton">

    <div matTooltip="{{ 'addNewRow' | translate }}"
         matTooltipClass="big-tooltip">
      <button mat-mini-fab
              color="primary"
              type="button"
              (click)="addNewRow()">
        <mat-icon>add</mat-icon>
      </button>
    </div>

  </div>
</div>
